import styled from 'styled-components/macro';
import colors from 'Common/constants/colors';
import {
    Tab as ReactTab,
    TabList as ReactTabList,
    TabPanel as ReactTabPanel,
    Tabs as ReactTabs,
} from 'react-tabs';

export const Tabs = styled(ReactTabs)``;

export const TabList = styled(ReactTabList)`
    position: relative;
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 0 -10px;
    padding: 0;
    background: #2f2c2b;
    list-style-type: none;
    text-align: center;
    z-index: 1;
`;

export const StickyTabList = styled(TabList)`
    @media screen and (min-width: 940px) {
        position: sticky;
        top: 81px;
    }
`;

export const Tab = styled(ReactTab)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    margin-left: 10px;
    margin-bottom: 10px;
    min-width: 250px;
    padding: 13px 15px;
    background: ${colors.DARKEST_GRAY};
    border: 1px solid ${colors.LIGHT_GRAY};
    color: ${colors.LIGHTER_GRAY};
    font-size: 14px;
    cursor: pointer;
    border-radius: 4px;

    &:focus {
        outline: 0 none;
        border-color: ${colors.ORANGE};
    }

    &.react-tabs__tab--selected {
        background: ${colors.DARK_GRAY};
        border-color: ${colors.DARK_GRAY};
        color: ${colors.ORANGE};

        &:focus {
            outline: 0 none;
            border-color: ${colors.ORANGE};
        }
    }

    @media screen and (min-width: 940px) {
        font-size: 16px;
    }
`;

export const TabPanel = styled(ReactTabPanel)``;
